import React from 'react';

export const IconUpload = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 100 100"
		fill="currentColor"
		stroke="currentColor"
		{...props}
	>
		<path d="M5.1 90.8l7.6-32.9c.3-1.4 1.5-2.5 3-2.7l42.5-4.4c1.2-.1 1.2-1.9 0-2.1l-42.5-4.1c-1.5-.1-2.7-1.2-3-2.6L5.1 9.2C4.4 6.4 7.4 4.1 10 5.4L93.1 47c2.5 1.3 2.5 4.9 0 6.2L10 94.6c-2.6 1.3-5.6-1-4.9-3.8z"></path>
	</svg>
);
